import { render, staticRenderFns } from "./BrandLogoLoader.vue?vue&type=template&id=7c7c4316&scoped=true"
import script from "./BrandLogoLoader.vue?vue&type=script&lang=js"
export * from "./BrandLogoLoader.vue?vue&type=script&lang=js"
import style0 from "./BrandLogoLoader.vue?vue&type=style&index=0&id=7c7c4316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7c4316",
  null
  
)

export default component.exports